import { HttpLink } from '@apollo/client';
import { API_URL } from '../../constants/api';

export const SIGN_UP_QUERY_NAME = 'signUpBeta';

export const signUpLink = new HttpLink({
  uri: process.env.REACT_APP_ENVIRONMENT === 'production' ? process.env.REACT_APP_SIGNUP_BETA_URL : API_URL,
  credentials: 'same-origin',
});
